export default {
  saveUserData: {
    error: null,
    loading: false,
    success: false,
  },
  updateUserPhoneList: {
    error: null,
    loading: false,
    success: false,
  },
  updateUserEmailList: {
    error: null,
    loading: false,
    success: false,
  },
  deletePhone: {
    error: null,
    loading: false,
    success: false,
  },
  updateSecurityQuestions: {
    error: null,
    loading: false,
    success: false,
  },
  updatePassword: {
    error: null,
    loading: false,
    success: false,
  },
  updatePIN: {
    error: null,
    loading: false,
    success: false,
  },
  updateDOB: {
    error: null,
    loading: false,
    success: false,
  },
  updateGender: {
    error: null,
    loading: false,
    success: false,
  },
  switchToBusinessAccount: {
    error: null,
    loading: false,
    success: false,
  },
  businessType: {
    error: null,
    loading: false,
    data: [],
  }
};
